"use client";

import Link from "next/link";
import YourVehicle from "./YourVehicle";
import { routes } from "@/lib/utils/routes";

const VehicleDetail = ({ t, vehicle, handleChangeVehicle }) => {
  return (
    <>
      <YourVehicle t={t} />
      <div className="selectValueBox">
        <div className="findByRegistrationBox export">
          <div className="flex justify-between xs:flex-row flex-col">
            <div className="inputBox">
              <div className="input-container relative">
                <div className="w-12/12 block relative">
                  <input
                    disabled
                    type="text"
                    className="input"
                    placeholder={vehicle}
                  />
                </div>
              </div>
              <button
                onClick={handleChangeVehicle}
                className="blue-underlined absolute right-[30px] text-primary-blue-900 max-w-max"
              >
                <span>{t("current_vehicle.change_vehicle")}</span>
              </button>
            </div>
            <Link href={routes.parts} className="green-btn" prefetch={false}>
              {t("current_vehicle.exploreParts")}
            </Link>
          </div>
        </div>
      </div>
    </>
  );
};

export default VehicleDetail;
